import { FormInput } from "@holigral/shared/form"
import { useT } from "@/i18n"

/**
 * The given and family name inputs of a ProfilePayload form, shared by the
 * account settings and the questionnaire's name prompt
 */
export default function NameFields() {
  const { t } = useT()

  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:gap-4">
      <FormInput
        name="givenName"
        label={t("profile.givenName")}
        autoComplete="given-name"
        maxLength={100}
        required
        className="w-full"
      />
      <FormInput
        name="familyName"
        label={t("profile.familyName")}
        autoComplete="family-name"
        maxLength={100}
        required
        className="w-full"
      />
    </div>
  )
}
